import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the window to top whenever the route pathname changes.
 * Fixes the mobile bug where navigating to a new page kept the previous
 * page's scroll offset, causing the first product to appear mid-viewport.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    // instant so the user doesn't see a scroll animation on navigation
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}
